import React from 'react'
import styled from 'styled-components'
import MomentTz from 'moment-timezone'
import { extendMoment } from 'moment-range'
const moment = extendMoment(MomentTz)

const LastUpdatedText = styled.div`
  text-align: right
  color: grey
  font-size: 12px
  margin-bottom: 12px
`

const SystemStatus = ({ inTimezone }) => {
  const refreshDate = moment().tz(inTimezone)

  return (
    <LastUpdatedText>
      Updated {refreshDate.format("h:mm a z")}
    </LastUpdatedText>
  )
}

export default SystemStatus
